import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from "@tanstack/react-query";

import { QueryKeys } from "@/constants/query.keys";

type QueryRestKeys = Array<{ [key: string]: unknown }>;

type QueryArray = readonly [QueryKeys, ...QueryRestKeys];
/**
 * @how_to_use This is function-wrapper for useQuery, but it requires to use a constant from \src\constants\query.keys.ts as first element of the queryKey array argument
 */
export function useQueryCashed<
  TQueryFnData = unknown,
  TError = unknown,
  TData = TQueryFnData,
  TQueryKey extends QueryArray = QueryArray,
>(
  options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
): UseQueryResult<TData, TError> {
  return useQuery({ retry: 1, ...options });
}
